/* eslint-disable camelcase */
import { HumanEntry } from './HumanEntry'
import { LightConditionsEntry } from './LightConditionsEntry'
import { ActionsEntry } from './ActionsEntry'
import { DetectorBeltEntry } from './DetectorBeltEntry'
import { DetectorPhoneEntry } from './DetectorPhoneEntry'
import { DetectorFoodEntry } from './DetectorFoodEntry'
import { DetectorSmokeEntry } from './DetectorSmokeEntry'
import { DetectorFrameHands } from './DetectorFrameHands'

import snakeCase from 'lodash.snakecase'

export class CriticalDatasetEntry {
  constructor ({ human, light_conditions, actions, belt, phone, food, smoke, hand_frame, comment, is_empty, slides = [] } = {}) {
    this.human = new HumanEntry(human)
    this.lightConditions = new LightConditionsEntry(light_conditions)
    this.actions = new ActionsEntry(actions)
    this.belt = new DetectorBeltEntry(belt)
    this.phone = new DetectorPhoneEntry(phone)
    this.food = new DetectorFoodEntry(food)
    this.smoke = new DetectorSmokeEntry(smoke)
    this.handFrame = new DetectorFrameHands(hand_frame)
    this.comment = comment
    this.isEmpty = is_empty
    this.filters = this._filterInitialization()
    this.slides = slides
  }

  backendModel () {
    /**
     * backend dataset representation,
     * in case of new field addition it is required to add field here!
     */
    return {
      human: this.human.backendModel(),
      light_conditions: this.lightConditions.backendModel(),
      actions: this.actions.backendModel(),
      belt: this.belt.backendModel(),
      phone: this.phone.backendModel(),
      food: this.food.backendModel(),
      smoke: this.smoke.backendModel(),
      hand_frame: this.handFrame.backendModel(),
      comment: this.comment,
      slides: this.slides
    }
  }

  filterModel () {
    /**
     * backend dataset filters representation
     * in case of new field addition it is required to add field here!
     */
    return {
      human: this.filters.human.map(item => snakeCase(item)),
      light_conditions: this.filters.lightConditions.map(item => snakeCase(item)),
      actions: this.filters.actions.map(item => snakeCase(item)),
      belt: this.filters.belt.map(item => snakeCase(item)),
      phone: this.filters.phone.map(item => snakeCase(item)),
      food: this.filters.food.map(item => snakeCase(item)),
      smoke: this.filters.smoke.map(item => snakeCase(item)),
      hand_frame: this.filters.handFrame.map(item => snakeCase(item)),
    }
  }

  isFilterEmpty () {
    let isEmpty = true
    for (const usedFields of Object.values(this.filters)) {
      if (usedFields.length > 0) {
        isEmpty = false
        break
      }
    }

    return isEmpty
  }

  _filterInitialization () {
    const result = {}
    for (const field of Object.keys(this)) {
      if (this[field] && this[field] !== undefined && this[field].textRepresentation instanceof Array) {
        result[field] = [] // toggled field storage
      }
    }

    return result
  }

  get datasetCategories () {
    let result = []
    for (const field of Object.keys(this)) {
      if (this[field] !== undefined && this[field].textRepresentation instanceof Array) {
        result = result.concat(...this[field].textRepresentation)
      }
    }

    return result
  }
}
